import { render, staticRenderFns } from "./AuctionSettings.vue?vue&type=template&id=ffaa27ba&"
import script from "./AuctionSettings.vue?vue&type=script&lang=js&"
export * from "./AuctionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports